<div class="d-flex align-items-center justify-content-between mm-mb-3">
  <h2 class="mm-mb-0">Consultation Summary / Clinician's Instructions to Patient</h2>
  <button mat-icon-button [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-divider></mat-divider>

<mat-dialog-content class="mm-my-4">
  <form [formGroup]="consultationForm" class="consultation-form">
    <!-- Main instruction text -->
    <!-- Main instruction text -->
    <p class="instruction-text mm-mb-4 mm-mt-3">
      Enter or paste your instructions for the patient. These will be included in their
      post-consultation summary email.
      <app-custom-tooltip [content]="tooltipText"></app-custom-tooltip>
    </p>

    <!-- Clinician Instructions Field -->
    <div class="form-field-wrapper">
      <label class="field-label">
        Clinician Instructions <span class="required">*</span>
        <small class="character-count-subtle">
          ({{ getCharacterCount('clinicianInstructions') }} chars)
        </small>
      </label>
      <quill-editor
        theme="snow"
        formControlName="clinicianInstructions"
        [modules]="quillConfig"
        placeholder="Enter instructions for the patient..."
        class="editor-field"
      >
      </quill-editor>
      @if (consultationForm.get('clinicianInstructions')?.invalid &&
      consultationForm.get('clinicianInstructions')?.touched) {
      <div class="error-message">
        {{ getErrorMessage('clinicianInstructions') }}
      </div>
      }
    </div>

    <!-- Diagnosis Field (only for Express Consults) -->
    @if (isExpressConsult) {
    <div class="form-field-wrapper">
      <label class="field-label">
        Diagnosis <span class="required">*</span>
        <small class="character-count-subtle">
          ({{ getCharacterCount('diagnosis') }} chars)
        </small>
      </label>
      <quill-editor
        theme="snow"
        formControlName="diagnosis"
        [modules]="quillConfig"
        placeholder="Enter the diagnosis..."
        class="editor-field"
      >
      </quill-editor>
      @if (consultationForm.get('diagnosis')?.invalid &&
      consultationForm.get('diagnosis')?.touched) {
      <div class="error-message">
        {{ getErrorMessage('diagnosis') }}
      </div>
      }
    </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="mm-pt-2">
  <button mat-button (click)="onCancel()" class="mm-mr-2">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="!consultationForm.valid"
  >
    Continue
  </button>
</mat-dialog-actions>
